<template>
  <span
    v-if="label"
    class="status-badge"
    :data-tone="tone"
    :title="status.title"
  >
    <span class="status-badge__dot" aria-hidden="true"></span>{{ label }}
  </span>
</template>

<script>
// Stato di una polizza, di un titolo o di una quietanza come badge colorato:
// <status-badge kind="policy" :status="item.status_policy" />
// (status è l'enum del backend: { value, text }, con un title facoltativo per
// il testo intero di un'etichetta accorciata). Toni in utils/statusBadge.js.
import { statusTone } from "@/utils/statusBadge";

export default {
  name: "StatusBadge",
  props: {
    kind: { type: String, required: true },
    status: { type: Object, default: null },
  },
  computed: {
    label() {
      return this.status?.text || "";
    },
    tone() {
      return statusTone(this.kind, this.status?.value);
    },
  },
};
</script>

<style lang="scss" scoped>
// Il fondo è il pallino al 12%: una pillola per tono senza altri token.
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  // Pillola anche su più righe: le etichette lunghe ("Annullati manualmente
  // + annullo polizza") vanno a capo invece di allargare la colonna.
  border-radius: 10px;
  font-size: var(--font-size-sm);
  font-weight: 600;
  line-height: 15px;
  color: var(--tone);
  background: color-mix(in srgb, var(--tone-dot) 12%, transparent);

  @each $tone in ok, open, wait, ko, off {
    &[data-tone="#{$tone}"] {
      --tone: var(--status-#{$tone});
      --tone-dot: var(--status-#{$tone}-dot);
    }
  }
}

.status-badge__dot {
  flex: none;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--tone-dot);
}
</style>
